import { render, staticRenderFns } from "./digitalSurveyDetail.vue?vue&type=template&id=87808a30&scoped=true&"
import script from "./digitalSurveyDetail.vue?vue&type=script&lang=js&"
export * from "./digitalSurveyDetail.vue?vue&type=script&lang=js&"
import style0 from "./digitalSurveyDetail.vue?vue&type=style&index=0&id=87808a30&prod&lang=scss&"
import style1 from "./digitalSurveyDetail.vue?vue&type=style&index=1&id=87808a30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87808a30",
  null
  
)

export default component.exports